import { render, staticRenderFns } from "./SupplierAccept.vue?vue&type=template&id=502377c6&"
import script from "./SupplierAccept.vue?vue&type=script&lang=js&"
export * from "./SupplierAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports